module.exports = __webpack_public_path__ + "static/img/icon-mall-world.217b1f1f.png";